import { EventDetail } from 'model/modules/events/eventDetail';
import moment from 'moment';
import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';
import mapEventCategoryFromApi from './mapEventCategoryFromApi';

const mapEventDetailFromApi = (resp: ApiEventDetail): EventDetail => {
  return {
    id: resp.id,
    name: resp.name,
    subtitle: resp.subtitle,
    preview: resp.preview.url ?? '',
    photoLimit: resp.photo_limit,
    startDate: moment(resp.start_date, 'DD.MM.yyyy hh:mm:ss').toDate(),
    status: resp.status,
    description: resp.description,
    descriptionTitle: resp.description_title,
    presentation: resp.presentation?.url ?? null,
    photos: resp.photos.map(mapFileFromApi),
    videoUrl: resp.video_url,
    category: mapEventCategoryFromApi(resp.type),
  };
};

export default mapEventDetailFromApi;
